import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useReturnToStore = defineStore('returnTo', () => {
  const path = ref<string | null>(null);

  // Set when navigating into a detail page from "somewhere else"
  function set(p: string) {
    path.value = p;
  }

  // Read and optionally clear after use
  function consume(): string | null {
    const p = path.value;
    path.value = null;
    return p;
  }

  function peek(): string | null {
    return path.value;
  }

  return { path, set, consume, peek };
});
